<div class="hidden md:!inline">
  <div class="margine-tab" *ngIf="checkbox">
    <div [class]="'w-full h-full flex items-center justify-center shadow-lg bg-primary head-checkbox '+ headerClass">
      <std-checkbox [backGroundFalse]="bgCheckFalse" [backGroundTrue]="bgCheckTrue"
        (onChange)="onCheckboxChangeAll($event)"></std-checkbox>
    </div>
    <div class="fake-row"></div>
    <div class="w-full h-full !rounded-lg !shadow-lg bg-white">
      <div [class]="'flex items-center justify-center bg-white ' + containerCheckbox"
        *ngFor="let item of data; let i = index">
        <div class="flex items-center place-content-center bg-white" [style.height.px]="(rowHeights | async)?.[i]">
          <std-checkbox [backGroundFalse]="bgCheckFalse" [backGroundTrue]="bgCheckTrue" [isChecked]="item.checked"
            (onChange)="onCheckboxChange($event, item)"></std-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="rounded-xl bg-inherit pb-2.5">
    @if(data?.length > 0 ){<table id="table2" class="w-full border-collapse">
      @if(title){<caption
        class="text-left font-medium text-inherit text-opacity-80 bg-inherit px-3.5 text-sm pt-4 -mb-[5px] rounded-t-xl">
        {{ title }}
      </caption>}
      <thead class="px-2.5 rounded-t-xl rounded-lg shadow-lg">
        <tr [class]="'text-xs text-left bg-primary text-white rounded-lg ' + headerClass">
          <th *ngFor="let column of columns"
            class="text-inherit text-xs font-medium py-2 px-1 md:!py-4 md:!px-3.5 uppercase">
            <span *ngIf="column.headerTemplate" [ngTemplateOutletContext]="{ column: column }"
              [ngTemplateOutlet]="column.headerTemplate">
            </span>
            <span *ngIf="!column.headerTemplate" [textContent]="column.label"></span>
          </th>
        </tr>
      </thead>
      <div style="height: 10px"></div>
      <tbody *ngIf="(_data | async)?.length > 0" class="rounded-lg top-2.5 shadow-lg">
        <tr #row id="row-{{i}}" stdoutTableRow [class]="'rounded-lg bg-white text-font13px text-black ' + bodyClass"
          [ngClass]="{ 'cursor-pointer': withHover, 'border-b border-[#E7E9F1]': stripes }" [columns]="columns"
          [item]="item" [index]="i" (click)="onRowClick($event, item)"
          *ngFor="let item of _data | async; let i = index">
        </tr>
      </tbody>
      <!-- <tbody *ngIf="data?.length === 0">
        <tr>
          <td [colSpan]="columns.length">
            <div class="p-5 text-center">{{noDataText}}</div>
          </td>
        </tr>
      </tbody> -->
    </table>}@else {
      <div class="flex justify-center items-center py-16">
      <div class="
        w-full max-w-md
        rounded-3xl
        border border-blue-100
        bg-gradient-to-br from-white to-blue-50
        shadow-lg
        p-8
        text-center
    ">

        <!-- Icona -->
        <div class="
            mx-auto mb-5
            flex items-center justify-center
            w-20 h-20
            rounded-full
            bg-blue-100
            text-blue-600
        ">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
          </svg>
        </div>

        <!-- Titolo -->
        <h3 class="
            text-xl
            font-bold
            text-slate-800
            mb-2
        ">
          Nessun risultato trovato
        </h3>

        <!-- Descrizione -->
        <p class="
            text-slate-500
            text-sm
            leading-6
            mb-6
        ">
          Non ci sono elementi che corrispondono ai filtri selezionati.
          <!-- Prova a modificare i criteri di ricerca. -->
        </p>

        <!-- Badge informativo -->
        <!-- <div class="
            inline-flex
            items-center
            gap-2
            px-4 py-2
            rounded-full
            bg-blue-50
            text-blue-700
            text-sm
            font-medium
        ">
          <span class="w-2 h-2 rounded-full bg-blue-500"></span>
          Filtri attivi senza risultati
        </div> -->

      </div>
    </div>
    }
  </div>
</div>
<!-- Mobile -->
<div class="md:hidden w-full rounded-[12px]">
  <div class="rounded-xl bg-inherit">
    <div *ngIf="(_data | async)?.length > 0" class="top-2.5 grid gap-4">
      <div (expand)="mobileItemExpanded == i? mobileItemExpanded =-1: mobileItemExpanded = i" #row id="row-{{i}}"
        [tableTitle]="tableTitle" stdoutMobileTableRow
        [class]="'bg-white text-font13px text-black shadow-lg rounded-xl ' + bodyClass"
        [ngClass]="{ 'cursor-pointer': withHover, 'border-b border-[#E7E9F1]': stripes }" [columns]="columns"
        [item]="item" [mobileItemExpanded]="mobileItemExpanded" [index]="i" (click)="onRowClick($event, item)"
        *ngFor="let item of _data | async; let i = index">
      </div>
    </div>
    <div *ngIf="data?.length === 0 " class="flex justify-center items-center py-16">
      <div class="
        w-full max-w-md
        rounded-3xl
        border border-blue-100
        bg-gradient-to-br from-white to-blue-50
        shadow-lg
        p-8
        text-center
    ">

        <!-- Icona -->
        <div class="
            mx-auto mb-5
            flex items-center justify-center
            w-20 h-20
            rounded-full
            bg-blue-100
            text-blue-600
        ">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
          </svg>
        </div>

        <!-- Titolo -->
        <h3 class="
            text-xl
            font-bold
            text-slate-800
            mb-2
        ">
          Nessun risultato trovato
        </h3>

        <!-- Descrizione -->
        <p class="
            text-slate-500
            text-sm
            leading-6
            mb-6
        ">
          Non ci sono elementi che corrispondono ai filtri selezionati.
          <!-- Prova a modificare i criteri di ricerca. -->
        </p>

        <!-- Badge informativo -->
        <!-- <div class="
            inline-flex
            items-center
            gap-2
            px-4 py-2
            rounded-full
            bg-blue-50
            text-blue-700
            text-sm
            font-medium
        ">
          <span class="w-2 h-2 rounded-full bg-blue-500"></span>
          Filtri attivi senza risultati
        </div> -->

      </div>
    </div>
  </div>
</div>